/**
 * Client-side person-name rules aligned with BE `personNameSchema`
 * (DEF-263 digits allowed; DEF-213 / DEF-239 markup rejected).
 */

/** Max length for first/last name (matches BE + invite inputs). */
export const PERSON_NAME_MAX_LENGTH = 50;

const PERSON_NAME_MESSAGE =
  'Name may only include letters, numbers, spaces, hyphens, apostrophes, and periods';

/** True when the string contains `<`, `>`, or ASCII control characters. */
function hasForbiddenNameChars(value: string): boolean {
  for (let i = 0; i < value.length; i += 1) {
    const code = value.charCodeAt(i);
    if (code === 0x3c || code === 0x3e) return true;
    if (code <= 0x1f || code === 0x7f) return true;
  }
  return false;
}

/**
 * Validate a non-empty person name. Returns an error message or `null` when valid.
 * Callers treat blank separately when the field is required.
 */
export function validatePersonName(value: string): string | null {
  const trimmed = value.trim();
  if (!trimmed) return null;
  if (trimmed.length > PERSON_NAME_MAX_LENGTH) {
    return PERSON_NAME_MESSAGE;
  }
  if (hasForbiddenNameChars(trimmed)) {
    return PERSON_NAME_MESSAGE;
  }
  if (!/^[\p{L}\p{M}\p{N}\s'.-]+$/u.test(trimmed)) {
    return PERSON_NAME_MESSAGE;
  }
  return null;
}
